<template>
  <div></div>
</template>

<script>
/**
 * Carrier List V2
 * @displayName Carrier List V2
 */
export default {
  mixins: [],
  data() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>
